import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import TabComponent from '../../../../common/components/TabComponent';
import RedirectionModal from '../../../../common/components/modal/RedirectionModal';
import {useRedirectionModal} from '../../../../common/components/modal/hooks/useRedirectionModal';
import Level3Title from '../../../../common/components/title/Level3Title';

interface RedirectCardProps {
    title: string;
    description: string;
    buttonLabel: string;
    url: string;
    onRedirect: (url: string) => void;
}

const RedirectCard = ({title, description, buttonLabel, url, onRedirect}: RedirectCardProps): JSX.Element => (
    <div className="row g-4 mt-1">
        <div className="col-12 col-xxl-6">
            <Card>
                <Card.Header>
                    <Card.Title>
                        <Level3Title title={title} />
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <p>{description}</p>
                    <button className="btn btn-primary" onClick={() => onRedirect(url)}>
                        {buttonLabel}
                    </button>
                </Card.Body>
            </Card>
        </div>
    </div>
);

const RouteursDesk = (): JSX.Element => {
    const intl = useIntl();
    const [activeTab, setActiveTab] = useState('internet');
    const {isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl, countdown} =
        useRedirectionModal();

    const handleRedirect = (targetUrl: string) => {
        const redirectUrl = `/ec-desk?next=${encodeURIComponent(targetUrl)}`;
        confirmRedirection(redirectUrl);
    };

    return (
        <>
            <TabComponent
                tabData={[
                    {
                        title: intl.formatMessage({id: 'CONFIGURATION.INTERNET'}),
                        key: 'internet',
                        content: (
                            <RedirectCard
                                title={intl.formatMessage({id: 'CONFIGURATION.INTERNET'})}
                                description={intl.formatMessage({id: 'ROUTEURS.INTERNET.DESC'})}
                                buttonLabel={intl.formatMessage({id: 'CONFIGURATION.INTERNET'})}
                                url="https://extranet2.stella-telecom.fr/internet"
                                onRedirect={handleRedirect}
                            />
                        ),
                    },
                    {
                        title: intl.formatMessage({id: 'CONFIGURATION.PROXY'}),
                        key: 'proxy',
                        content: (
                            <RedirectCard
                                title={intl.formatMessage({id: 'CONFIGURATION.PROXY'})}
                                description={intl.formatMessage({id: 'ROUTEURS.PROXY.DESC'})}
                                buttonLabel={intl.formatMessage({id: 'CONFIGURATION.PROXY'})}
                                url="https://extranet2.stella-telecom.fr/proxy"
                                onRedirect={handleRedirect}
                            />
                        ),
                    },
                ]}
                activeKey={activeTab}
                onTabChange={setActiveTab}
            />
            <RedirectionModal
                show={isOpen}
                onCancel={closeModal}
                onContinue={handleContinue}
                url={pendingUrl || ''}
                countdown={countdown}
            />
        </>
    );
};

export default RouteursDesk;
